
import {Component, Vue} from "vue-property-decorator";

@Component({
  components:{}
})
export default class YapimAsamasinda extends Vue{

  mounted() {
    console.log("yapimasamasinda mounted.")
    if (!this.$store.getters.isImzaConnected)
      this.$store.dispatch("checkUyapSession");
  }

}
